// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_fy-6";
export var emphasizeQuantity = "_fy-3";
export var flatBottomCorners = "_fy-5";
export var productImage = "_fy-0";
export var quantityContainer = "_fy-2";
export var tooltip = "_fy-1";
export var wrapAndEllipsesOverflow = "_fy-4";